<template>
  <v-card class="recharge mw-700 mx-auto" elevation="0">
    <div v-if="!successData">
      <v-form ref="form" @submit.prevent="validate" lazy-validation>
        <v-row>
          <v-col cols="12" sm="8" align-self="center">
            <h1 class="mw-300">
              <span class="d-block">
                {{ $t('recharge.with') }}
              </span>
              {{ $t('recharge.billet.title') }}
            </h1>
          </v-col>
          <v-col cols="12" sm="4" align-self="center">
            <HAmount @input="getAmount" :minAmount="200" class="ml-auto" />
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-textarea
              @input="handleUpdateRechargeFields"
              v-model="comment"
              :label="$t('recharge.comment')"
              outlined
              hide-details
            />
          </v-col>
        </v-row>


      <v-row>
        <v-col>
          <v-alert type="warning">
            {{ $t('recharge.billet.warningMessage') }}
          </v-alert>
        </v-col>
      </v-row>

        <div class="text-right">
          <v-btn
            @click="setRechargeFields({ type: null })"
            :disabled="isLoading"
            class="mr-5"
            color="grey"
            elevation="0"
            large
            text
          >
            <v-icon left> mdi-chevron-left </v-icon>
            {{ $t('recharge.navigation.goBack') }}
          </v-btn>

          <v-btn
            @click="validate"
            :loading="isLoading"
            color="primary"
            elevation="0"
            large
          >
            {{ $t('recharge.billet.withBillet') }}
          </v-btn>
        </div>
      </v-form>
    </div>

    <RechargeSuccess v-else />
  </v-card>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

import HAmount from '@/components/app/HAmount'
import RechargePersonalFields from './formFields/RechargePersonalFields'
import RechargeSuccess from './formFields/RechargeSuccess'

export default {
  name: 'RechargeByBillet',

  components: {
    HAmount,
    RechargePersonalFields,
    RechargeSuccess,
  },

  computed: {
    ...mapGetters(['successData', 'rechargeFields', 'isLoading']),
  },

  methods: {
    ...mapActions(['handleRecharge']),
    ...mapMutations(['setRechargeFields', 'setSuccessData']),

    validate() {
      if (this.$refs.form.validate()) {
        this.handleRecharge()
      }
    },

    getAmount(value) {
      this.setRechargeFields({ value })
    },

    handleUpdateRechargeFields() {
      this.setRechargeFields({...{ comment: this.comment }})
    },
  },

  data() {
    return {
      comment: null
    }
  }
}
</script>
